import { createDecorator } from '../../instantiation/common/instantiation.js';
const IAccessibilityService = ( createDecorator('accessibilityService'));
export { IAccessibilityService };
